/**
 * Location Edit
 *
 * The functionality here was taken from LocationEdit.js and the markup was
 * changed as little as possible to ease the move of other fields
 *
 * @author MattJS (matt@yext.com)
 */

goog.provide('yext.location');
goog.provide('yext.location.events');
goog.provide('yext.location.LocationField');

goog.require('yext.notify');
goog.require('yext');
goog.require('yext.Field');
goog.require('yext.approvals.tooltip');
goog.require('yext.basicentity.verification');
goog.require('yext.basiclocation');
goog.require('yext.basiclocation.verification');
goog.require('yext.dam.assetselector');
goog.require('yext.dialog');
goog.require('yext.gmb');
goog.require('yext.helpers');
goog.require('yext.listings.wizard');
goog.require('yext.location.Address');
goog.require('yext.location.Date');
goog.require('yext.location.DateTime');
goog.require('yext.location.DateTimeRange');
goog.require('yext.location.OptionList');
goog.require('yext.location.Phone');
goog.require('yext.location.ecl.EnhancedList');
goog.require('yext.location.Education');
goog.require('yext.location.EventLocation');
goog.require('yext.location.GasStationFeatures');
goog.require('yext.location.GasStationFeaturesView');
goog.require('yext.location.HealthcareName');
goog.require('yext.location.LocationTypeUpdater');
goog.require('yext.location.ReferenceValueList');
goog.require('yext.location.MultipleSelect');
goog.require('yext.location.Phones');
goog.require('yext.location.SearchableMultipleSelect');
goog.require('yext.location.Select');
goog.require('yext.location.VideoGalleryView');
goog.require('yext.location.categories.CategoryField');
goog.require('yext.location.categories.CategoriesWarningDialog');
goog.require('yext.location.coupon');
goog.require('yext.location.custom.times.daily');
goog.require('yext.location.externalurl');
goog.require('yext.location.facebook.ViewController');
goog.require('yext.location.gallery');
goog.require('yext.location.gallery.browse');
goog.require('yext.location.GoogleAttributeGroup');
goog.require('yext.location.helpers');
goog.require('yext.location.hours.DayHours');
goog.require('yext.location.image.Image');
goog.require('yext.location.image.ImageField');
goog.require('yext.location.image.ImageListField');
goog.require('yext.location.keywords');
goog.require('yext.location.labels');
goog.require('yext.location.ml');
goog.require('yext.location.MapMarkerView');
goog.require('yext.location.NamedUrlList');
goog.require('yext.location.Number');
goog.require('yext.location.photo');
goog.require('yext.location.radio');
goog.require('yext.location.Location');
goog.require('yext.location.RichText');
goog.require('yext.location.SpecialOffer');
goog.require('yext.location.pill');
goog.require('yext.location.List');
goog.require('yext.location.util');
goog.require('yext.location.UberLaunchLink');
goog.require('yext.location.video');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
goog.require('yext.storm.PageNav');
goog.require('yext.textfield');
goog.require('yext.textfield.embed');
goog.require('yext.videochooser');
goog.require('yext.locationcluster');
goog.require('yext.locationcluster.ClusterGuard');
goog.require('yext.location.FacebookCta');
goog.require('yext.location.UberTripBranding');
goog.require('yext.location.UberEmbedLink');
goog.require('yext.location.Websites');
goog.require('yext.scheduledupdates');
goog.require('yext.scheduledupdates.dialog.CancelDialog');
goog.require('yext.scheduledupdates.dialog.RescheduleDialog');
goog.require('yext.scheduledupdates.dialog.RevertDialog');
goog.require('yext.location.FoursquareOffer');
goog.require('yext.location.SectionSidebar');
goog.require('yext.location.IntegerRangeSelect');
goog.require('yext.location.EntityLabels');
goog.require('yext.entity.edit.EntityCluster');
goog.require('yext.entity.edit.EntityClusterGuard');
goog.require('yext.entity.fields.CompoundAddress');
goog.require('yext.entity.fields.ecl.EnhancedList');
goog.require('yext.entity.fields.PriceRange');
goog.require('yext.entity.fields.video.YouTubeVideoField');
goog.require('yext.entity.fields.video.YouTubeVideoListField');
goog.require('yext.entity.fields.Folder');
goog.require('yext.entity.fields.LinkedAccount');
goog.require('yext.location.GoogleRelationship');
goog.require('yext.location.Struct');
goog.require('yext.location.GenericList');

goog.scope(function() {
  var _location = yext.location;
  var _locationutil = yext.location.util;

  var fieldMap = {};
  var fieldNameMap = {};
  var UID = 1;
  var UIDString = 'locationfieldUID';
  var saveMessage = yext.msg('Saving ...');
  var profileDate = yext.getUrlParams().date;

  var $profileTable;
  var $profileTableRow;

  /**
   * Location Field object
   *
   * This object handles generic bindings on the field and instantiates a Field
   * object which will allow the form to be submitted via ajax
   *
   * @constructor
   */
  _location.LocationField = function($row, $formOverride) {
    this.$row = $row;
    this.$display = $row.find('.field-display');
    this.$edit = $row.find('.field-edit');
    if ($formOverride) {
      this.$form = $formOverride;
    } else {
      this.$form = $row.find('.field-edit-form');
    }
    if (!this.$form.length) {
      this.$form = $row.find('.js-custom-goal-field-form');
    }
    this.isSuggestEditMode = $row.data('suggestEditMode');
    this.isFutureEditMode = $row.data('futureEditMode');
    this.hasScheduledUpdates = $row.data('hasScheduledUpdates');
    this.$scheduledUpdateActions = $row.find('.js-scheduled-update-actions');

    this.dialogTimeout = undefined;
    // Set UID and store in field map
    this.UID = UID++;
    this.$row.data(UIDString, this.UID);
    fieldMap[this.UID] = this;

    this.fieldName = _location.getFieldIdFromRow(this.$row);
    this.customFieldId = _location.getCustomFieldIdFromRow(this.$row);

    if (this.$form.length) {
      this.bindForm();
    }

    this.addField();
    this.bindScheduledUpdateActions();
  };

  /**
   * Field names for fields that should not have their contents escaped before display
   */
  _location.LocationField.UNESCAPED_FIELD_NAMES = [
    'location.twitter_handle',
    'location.instagram_handle'];

  /**
   * Construct Field class and bind standard edit interactions
   */
  _location.LocationField.prototype.bindForm = function() {
    this.field = new yext.Field(this.$form);
    this.bindEdit();
  };

  /**
   * Sets the field map. Allow for multiple fields with the same name as this
   * is needed for fields like holiday hours
   */
  _location.LocationField.prototype.addField = function() {
    if (!fieldNameMap[this.fieldName]) {
      fieldNameMap[this.fieldName] = [];
    }
    fieldNameMap[this.fieldName].push(this);
  };

  /**
   * Show save dialog
   */
  _location.LocationField.prototype.showDelayedProgressDialog = function() {
    this.dialogTimeout = yext.dialog.showDelayedProgressDialog(
      this.saveMessage ? this.saveMessage : saveMessage);
  };

  /**
   * Bind events to open and close edit state on a field
   */
  _location.LocationField.prototype.bindEdit = function() {
    var self = this;
    _location.bindContextualHelp(this.$edit);

    this.$form.on('beforeSubmit.field', function() {
      self.showDelayedProgressDialog();
      self.field.disableSubmit();
    });

    this.$form.on('save.field', function(e, response) {
      self.processSaveResponse(response);
    });

    this.$form.on('always.field', function() {
      self.hideDelayedProgressDialog();
    });

    this.$form.on('error.field', function() {
      self.showError(yext.msg('There was an error while saving.'));
      self.toggleEdit(true);
      self.field.enableSubmit();
    });

    this.$display.click(function(e) {
      if (!$(e.target).hasClass('no-edit')) {
        self.toggleEdit(true);
      }
      e.stopPropagation(); // This is important, combats a trigger from LocationEdit.js
    });

    this.$row.click(function(e) {
      if (!$(e.target).hasClass('no-edit') && !$(this).hasClass('profile-row-edit')) {
        self.toggleEdit(true);
      }
    });

    this.$edit.find('.js-cancel-edit').click(function(e) {
      // Timeout hack to make this happen after reset calls
      setTimeout(function() {
        self.field.disableSubmit();
      }, 0);
      self.toggleEdit(false);
      self.hideAllErrors();
      e.stopPropagation();
    });

    // Keep this from triggering the parent click
    this.field.$submitButton.click(function(e) {
      e.stopPropagation();
    });
  };

  /**
   * Process and render the path-specified style errors.
   *
   * @param {array} errors The list of errors to process and render.
   */
  _location.LocationField.prototype.processErrors = function(errors, fieldId) {
    errors = JSON.parse(errors);
    for (let i = 0; i < errors.length; i++) {
      let path = errors[i].path;
      let message = errors[i].message;
      let key = path[0]['name'];
      let $error =
        this.$form.find(':not(.generic-list-error).js-field-error[data-field-id="' + key + '"]');

      for (let j = 1; j < path.length; j++) {
        let step = path[j];
        if (step['index'] !== undefined) {
          $error = $error.eq(step['index']);
        } else {
          $error = $error
            .parents('div, li')
            .first()
            .find(':not(.generic-list-error).js-field-error[data-field-id="' + step['name'] + '"]');

          // If an error is coming in for a required subfield that is collapsed, open it to show
          // the error.
          $error
            .closest('.js-struct-child')
            .siblings('.js-show-struct-child-message[data-associated-prop-name=\'' + step['name'] + '\']')
            .find('.js-show-struct-child')
            .click();
        }
      }

      if ($error.length) {
        $error.text(message).show();
      } else if (fieldId != key) {
        $error =
          this.$form.find(':not(.generic-list-error).js-field-error[data-field-id="' + fieldId + '"]');
        message = yext.msg('Embedded Field Dependency Error: {0}', message);
        if ($error.length) {
          $error.text(message).show();
        } else {
          this.showGenericError();
        }
      } else {
        this.showGenericError();
      }
    }
    this.toggleEdit(true);
    this.field.enableSubmit();
  };

  /**
   * Process the save result for a field
   *
   * @param {!Object} response The save field response
   */
  _location.LocationField.prototype.processSaveResponse = function(response) {
    this.hideAllErrors(); // Start fresh
    if (response.stale) {
      this.showStaleError();
      this.toggleEdit(true);
    } else if (response.errors && typeof response.errors === 'string') {
      // cft-style path-specified errors will be under response.errors
      this.processErrors(response.errors, response.fieldId);
    } else if (response.error) {
      // non-path-specified errors will be under response.error
      if (typeof response.error == 'object') {
        for (var key in response.error) {
          if (key != 'details') {
            var $input = this.$row.find('[name^="' + key + '"]:visible');

            // For fieldIds with "virtual.expanded" at the beginning, use the definitionId instead
            if (!$input.length) {
              $input = this.$row.find('[data-definition-id^="' + key + '"]:visible');
            }
            var $error = yext.location.helpers.closestError($input);

            // Try and find a specified error div - useful for cases with several fields
            // in a single row, like structs.
            if (!$error.length) {
              $error = this.$form.find('.js-field-error[data-field-id="' + key + '"]');

              // We don't want to show errors for structs, but rather for their subfields.
              // If this error field is for a struct, skip it.
              if ($error.siblings('.js-struct-field-value').length) {
                continue;
              }

              // When rendering errors for generic list items we only want to show the error once.
              // Filter out list element level errors and only keep the container error div.
              $error = $error.filter(function() {
                return !$(this).parents('.js-generic-list-item').length;
              });
            }

            // If still haven't found an error div by this point, find any within the row
            if (!$error.length) {
              $error = this.$form.find('.js-field-error');
            }

            if (!$input.length && !$error.length) {
              this.showProfileError(response.error);
              break;
            } else if ($error.length) {
              $error.text(response.error[key]).show();
            } else {
              this.showGenericError();
            }
          } else {
            // TODO(mattjs): Use the error details for hours and holiday hours
            $(this).trigger('error.locationField', {
              error: $.parseJSON(response.error.details),
            });
          }
        }
      } else if (typeof response.error == 'string') {
        this.showError(response.error);
      }
      this.toggleEdit(true);
      this.field.enableSubmit();
    } else {
      this.$form.find('.js-ml-profile-asset-warning').hide();
      this.toggleEdit(false);
    }

    if (response.field) {
      var field = response.field;
      var metadata = response.metadata;
      this.updateTimestamp(field.timestamp);
      // Alternate profile inherited styles
      var overridableMode = field.isInherited === true;
      this.$row.toggleClass('overridable-mode', overridableMode);
      if (field.hasScheduledUpdates || (metadata && metadata.hasScheduledUpdates)) {
        this.hasScheduledUpdates = true;

        // Check if revert is available.
        // Location revert
        if (response.minRevertDate) {
          this.toggleScheduledUpdateElements(false);
          yext.scheduledupdates.dialog.RevertDialog(
            response.fieldIds,
            response.customFieldIds,
            response.minRevertDate);
        // Entity revert
        } else if (metadata) {
          // Highlight all fields that updates have been scheduled for
          for (var i in metadata.entityFieldIds) {
            const entityFieldId = metadata.entityFieldIds[i];
            var locationField =
              _location.getField(
                $('tr[data-field-id=\'' + entityFieldId + '\']'))
              || _location.getField(
                $('tr[data-field-id^=\'virtual.expanded.\'][data-field-id$=\'' + entityFieldId + '\']'));
            locationField.toggleScheduledUpdateElements(false);
          }
          if (metadata.minRevertDate) {
            yext.scheduledupdates.dialog.RevertDialog(
              null, // field ids
              null, // custom field ids
              metadata.minRevertDate,
              metadata.entityFieldIds);
          }
        }
      }
    }

    // Location Edit Field Flow, suggestedEdits should be handled elsewhere now
    // yext.approvals.helper.handleFieldUpdateResponse(this, response);

    // Refresh the suggested edit page after editing the content, clearing action too
    if (response.isSuggestedEdit && !(response.stale || response.error)) {
      var params = yext.getUrlParams();
      delete params.action;
      window.location.href = yext.buildUrlWithParams(window.location.href.split('?')[0], params);
    }
  };

  /**
   * Hide the loading dialog
   */
  _location.LocationField.prototype.hideDelayedProgressDialog = function() {
    yext.dialog.hideDelayedProgressDialog(this.dialogTimeout);
  };

  /**
   * Update the timestamp for a field
   *
   * @param {string} timestamp The timestamp for the field
   */
  _location.LocationField.prototype.updateTimestamp = function(timestamp) {
    if (this.fieldName == null) {
      return;
    }

    this.$form.find('.js-field-timestamp').val(timestamp);

    // Special case for custom fields: update the timestamps of all the
    // other custom fields to avoid stale updates
    if (this.fieldName.substring(0, 6) === 'custom'
        || this.fieldName.substring(0, 15) === 'location.custom'
        || this.fieldName.substring(0, 23) === 'virtual.location.custom') {
      $('[name^="custom"]').filter('[name$="timestamp"]').val(timestamp);
      $('[name^="location.custom"]').filter('[name$="timestamp"]').val(timestamp);
      $('[name^="virtual.location.custom"]').filter('[name$="timestamp"]').val(timestamp);
      $(yext.location.events).trigger('customFieldTimestampUpdated', timestamp);
    }
  };

  /**
   * Toggle the edit state for the field
   *
   * @param {boolean} show True if the field should be put in edit mode
   */
  _location.LocationField.prototype.toggleEdit = function(show) {
    if (!this.$row.hasClass('no-edit')) {
      this.$row.toggleClass('profile-row-edit', show);
      this.$display.toggle(!show);
      this.$edit.toggle(show);

      this.$row.closest('.field-row').toggleClass('editing', show);

      // Always try to focus on the first textarea/input in the field,
      // but ignore any date picker interactions
      if (show) {
        var $focus = this.$edit.find('input[type="text"]:visible,textarea:visible').first();
        if ($focus.length > 0 && !$focus.hasClass('js-holiday-date') && !$focus.hasClass('hasDatepicker')) {
          yext.setCaretPosition($focus, $focus.val().length);
        }
        // Hide all tooltips when entering edit mode
        window.hideContextualHelp();
        if (this.hasScheduledUpdates) {
          this.toggleScheduledUpdateElements(true);
        }
      } else {
        _location.setBeforeUnload();
        if (this.hasScheduledUpdates) {
          this.toggleScheduledUpdateElements(false);
        }
      }

      $(this).trigger('toggleFieldEdit', show);
    }
  };

  /**
   * Show a stale error message on a field
   */
  _location.LocationField.prototype.showStaleError = function() {
    yext.location.helpers.showStaleError(this.$edit);
  };

  /**
   * Show error on a field
   *
   * @param {string} value The error message
   */
  _location.LocationField.prototype.showError = function(value) {
    yext.location.helpers.showError(value, this.$edit);
  };

  /**
   * Returns true if error is visible
   *
   * @return {boolean} If an error is shown
   */
  _location.LocationField.prototype.hasError = function() {
    return this.$edit.find('.js-field-error').is(':visible');
  };

  /**
   * Hide an error
   */
  _location.LocationField.prototype.hideError = function() {
    yext.location.helpers.hideError(this.$edit);
  };

  /**
   * Hide all errors
   */
  _location.LocationField.prototype.hideAllErrors = function() {
    yext.location.helpers.hideAllErrors(this.$edit);
  };

  /**
   * Show a generic error, if the field has one
   */
  _location.LocationField.prototype.showGenericError = function() {
    this.$edit.find('.field-generic-error').show();
  };

  /**
   * Show an error affecting some other profile field, if the field has one
   *
   * @param {!Object} error Mapping from fields to update errors on those fields
   */
  _location.LocationField.prototype.showProfileError = function(error) {
    var errorDetails = '';
    var $fieldProfileError = this.$edit.find('.field-profile-error');
    for (var key in error) {
      errorDetails += '<br />' + _locationutil.formatFieldName(key) + ': ' + error[key];
    }
    $fieldProfileError.find('.js-error-details')
      .html(errorDetails)
      .end()
      .show();
  };

  /**
   * Updates the submit button text depending on asset selection and suggest edit mode
   *
   * @param {string} dataAttrName Name of button's data-* attribute that stores the text to display
   */
  _location.LocationField.prototype.updateSubmitButtonText = function(dataAttrName) {
    var button = this.$row.find('.edit-buttons button');
    var text = button.data(dataAttrName);
    button.find('span').text(text);
  };

  _location.LocationField.prototype.bindScheduledUpdateActions = function() {
    var self = this;
    yext.scheduledupdates.bindScheduledUpdateActions(
      function() {
        return self.fieldName;
      },
      function() {
        return self.customFieldId;
      },
      this.$scheduledUpdateActions,
      profileDate);
  };

  /**
   * Updates visibility of Scheduled Updates related UI elements for a field that has a Scheduled
   * Update.
   *
   * @param {boolean} isEditMode true iff the field is in edit mode
   *
   * Note: this method assumes the field has a scheduled update.
   */
  _location.LocationField.prototype.toggleScheduledUpdateElements = function(isEditMode) {
    if (this.isFutureEditMode) {
      var showActions = !!(isEditMode || this.$row.data('always-show-scheduled-updates-actions'));
      this.$row.find('.js-scheduled-update-label').toggle(!isEditMode);
      this.$scheduledUpdateActions.toggle(showActions);
      this.$row.toggleClass('scheduled-updates-highlight', true);
    }
  };

  /**
   * TODO SPR-511 (dlee): remove this Location Edit callback when removing locationsstorm
   * Specific callbacks for location page
   */
  var fieldVerificationCallbackOnLocationEdit = function(locationField, textField) {
    locationField.$form.on('beforeSubmit.field', function() {
      yext.basiclocation.verification.processLocationFieldReverification(locationField, textField);
    });

    locationField.$form.on('save.field', function(e, response) {
      if (!response.error) {
        // Special case for name field: update the name on top of the page
        if (locationField.fieldName == 'name') {
          if (textField.model.asset) {
            $('.location-name').html(yext.storm.location.util.generateEmbeddedFieldBadges(textField.model.asset.data));
          } else {
            $('.location-name').html(yext.storm.location.util.generateEmbeddedFieldBadges(textField.model.displayValue));
          }
          document.title = $('.page-title').text();
        }
      }
    });
  };

  /**
   * Field verification callback for Entity Edit page
   */
  var fieldVerificationCallbackOnEntityEdit = function(entityField, fieldId, dataFetcher) {
    entityField.$form.on('beforeSubmit.field', function() {
      if (yext.isFunction(dataFetcher)) {
        yext.basicentity.verification.processEntityFieldReverification(entityField, fieldId, dataFetcher());
      }
    });
  };

  // TODO SPR-511 (dlee): remove the Location Edit (false) case when removing locationsstorm
  var fieldVerificationCallback = $('.js-entity-edit-page-info').length > 0
    ? fieldVerificationCallbackOnEntityEdit
    : fieldVerificationCallbackOnLocationEdit;

  /**
   * Initialize location module
   *
   * @param {boolean} shouldBindFormOnEdit If false, initialize the edit form during initialization.
   *     If true, bind the form when the when the field is put into edit mode. This is only
   *     implemented on some fields. The purpose of delaying the bindings on the edit forms is only
   *     being done to reduce the time until the page is interactive.
   */
  _location.init = function(shouldBindFormOnEdit) {
    var profileTableSelector = '.profile-table';
    $profileTable = $(profileTableSelector),
    $profileTableRow = $profileTable.find('> tbody > tr');

    yext.locationcluster.init();
    yext.entitiescluster = new yext.entity.edit.EntityCluster($('.js-entity-cluster-module'));
    yext.scheduledupdates.init($('.js-scheduled-updates-sidebar'));

    new (goog.module.get('yext.approvals.tooltip').EntityToolTip)().init();

    yext.location.pill.bindPills();

    /**
     * General events for each field
     */
    $profileTableRow.each(function() {
      var $this = $(this);

      // This is the flag to use the new code
      if (!$this.find('.field-display').hasClass('field-display-new')) {
        // Note (egurevich): this is needed to support always showing SU actions for old-style fields,
        // as LocationEdit.js logic doesn't provide init hooks.
        _location.bindScheduledUpdateActionsForLegacyFields($this);

        return;
      }

      var locationField = new _location.LocationField($this);
      if (yext.entitiescluster.shouldShowWarningDialog(locationField.fieldName)
          && locationField.field) {
        yext.entitiescluster.createClusterGuard(locationField.field);
      }
    });

    yext.dam.assetselector.init({
      locationSearchParam: encodeURIComponent(window.location.search.substring(1)),
      alwaysUploadPhoto: true,
    });

    $.extend(yext.location.info, $('.js-location-info').data());
    _location.initOldStyleFields(profileTableSelector);

    _location.initFields(
      'tr',
      {
        fieldVerificationCallback: fieldVerificationCallback,
        shouldBindFormOnEdit: shouldBindFormOnEdit,
      });

    _location.initEducation();
    _location.initCategories();
    _location.initKeywords();
    _location.initLabels();
    _location.initNamedUrlList();
    _location.initRadio();
    yext.location.coupon.init();
    _location.initECL();
    _location.initFolderField();

    // initialize sidebar page nav
    var $sidebar = $('.js-section-sidebar');
    if ($sidebar.length) {
      new yext.storm.PageNav($sidebar, $('.location-edit-page-body'));
    }

    $('.js-single-photo').each(function() {
      yext.location.photo.create($(this));
    });

    yext.listings.wizard.initDialogs();
    // TODO(rzhang) remove this after supporting foursquare special for future edit
    if (!$('.js-scheduled-updates-sidebar').length) {
      yext.listings.wizard.initFoursquareLocEdit();
    }
    yext.location.ml.init();

    // TODO SPR-511 (dlee): remove this YahooFreeBasic sidebar init when deleting locationsstorm
    if ($('.js-yahoo-free-basic-sidebar').length === 0) {
      yext.basiclocation.init();
    }

    yext.videochooser.init('video.value', window.enableSubmit, window.onFieldSave);

    _location.initGMB();
    _location.initGoogleRelationship();
    _location.initGasStationFeatures();
  };
  goog.exportSymbol('yext.location.init', _location.init);

  /**
   * A fall back image for when things don't want to load.
   *
   * @param {function()} cb On load/error callback
   */
  _location.fallbackImage = function(cb) {
    var img = new Image();
    img.onload = function() {
      cb(this);
    };
    img.onerror = function() {
      cb(this);
    };
    img.src = '/s/public/images/photo-placeholder-160x120.png';
  };

  /**
   * Get the LocationField object associated with the field's row in the DOM
   *
   * @param {!jQuery} $row Row markup that wraps a location field
   */
  _location.getField = function($row) {
    return fieldMap[$row.data(UIDString)];
  };

  /**
   * Change the field to view mode when the approval flow is done
   *
   * @param {string} fieldName The name of the field that opened the asset selector
   */
  _location.closeField = function(fieldName) {
    var name = fieldName.split('.')[0];

    // TODO(billy) For whatever reason, it's possible for 'name' to not exist in fieldNameMap
    // which causes an exception to be thrown.
    // It's better to be defensive about this and fail gracefully;
    // but perhaps we want to figure out why the key doesn't exist in the first place?
    if (!Array.isArray(fieldNameMap[name])) {
      throw new TypeError('could not find field name: ' + name + ' in fieldname map');
    }

    fieldNameMap[name].forEach(function(field) {
      field.toggleEdit(false);
    });
  };
  goog.exportSymbol('storm.location.closeField', _location.closeField);

  /**
   * Initializes javascript needed for any field type
   *
   * @param {string} context The containing element for fields
   * @param {!Object} params Additional parameters for fields
   */
  _location.initFields = function(context, params) {
    params = params || {};
    _location.simpleTextFields(
      context,
      params.fieldVerificationCallback,
      params.shouldBindFormOnEdit,
    );
    _location.initExternalUrl(context);
    _location.initSpecialOffer(context);
    _location.initGallery(context);
    _location.initVideo(context);
    _location.initVideoGallery(context);
    _location.initImageFields(context);
    _location.initStruct(context, params.shouldBindFormOnEdit);
    _location.initList(context, params.shouldBindFormOnEdit);
    _location.initHours(context, params.hoursAfterSaveRender);
    _location.initTimes(context);
    _location.initMapMarker(context);
    _location.initSingleSelect(context);
    _location.initIntegerRangeSelect(context);
    _location.initEntityLabels(context);
    _location.initDate(context);
    _location.initRichText(context);
    _location.initLocationField(context);
    _location.initMultipleSelect(context);
    _location.initHealthcareName(context);
    _location.initListFields(context);
    _location.initUberLaunchLink(context);
    _location.initFacebookCta(context);
    _location.initUberTripBranding(context);
    _location.initFacebookFields(context, params.$facebookViewSelector);
    _location.initWebsites(context);
    _location.initNumber(context);
    _location.initGoogleAttributes();
    _location.initFoursquareOffer(context);
    _location.initPhones(context);
    _location.initDateTime(context);
    _location.initDateTimeRange(context);
    _location.initAddressFields(context, params.fieldVerificationCallback);
    _location.initEventLocation(context);
    _location.initOptionList(context);
    _location.initPhone(context);
    _location.initReferenceValue(context);
    _location.initReferenceValueListFields(context);
    _location.initYouTubeVideoField(context);
    _location.initPriceRange(context);
    _location.initYouTubeVideoListField(context);
    _location.initLinkedAccountField(context);
  };

  /**
   * Bind the linked account field
   */
  _location.initLinkedAccountField = function(ctx) {
    var $ctx = $('.js-entity-linked-account-edit', ctx);

    if ($ctx.length) {
      var linkedAccount = new yext.entity.fields.LinkedAccount($ctx);
      var locationField = _location.getField($ctx.closest(ctx));

      $(linkedAccount).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        linkedAccount.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          linkedAccount.set(response['field']);
          linkedAccount.storeValues();
          locationField.$display
            .empty()
            .append(linkedAccount.getDisplayValue());
        }
      });
    }
  };

  /**
   * Bind folder field
   */
  _location.initFolderField = function() {
    var $ctx = $('.js-folder-field');

    if ($ctx.length) {
      var folder = new yext.entity.fields.Folder($ctx);
      var locationField = _location.getField(folder.$ctx.closest('tr'));

      $(folder).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        folder.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          folder.set(response['field']);
          folder.storeValues();
          locationField.$display
            .empty()
            .append(folder.getDisplayValue(response['field']['folderName']));
        }
      });
    }
  };

  /**
   * Bind all price range fields
   */
  _location.initPriceRange = function(context) {
    $('.js-price-range-field', context).each(function() {
      var priceRange = new yext.entity.fields.PriceRange($(this));
      var locationField = _location.getField(priceRange.$ctx.closest(context));

      $(priceRange).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        priceRange.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          priceRange.set(response['field']);
          locationField.$display
            .empty()
            .append(priceRange.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize the reference value list fields
   */
  _location.initReferenceValueListFields = function(context) {
    $('.js-reference-location-link').click(e => {
      e.stopPropagation();
    });

    $('.js-reference-value-list-field', context).each(function() {
      var isChildOfStruct = $(this).parents('.js-struct-field').length > 0;
      if (isChildOfStruct) {
        return;
      }

      yext.location.ReferenceValueList.field($(this));
    });

    $('.js-reference-value-list-standalone', context).each(function() {
      var isChildOfStruct = $(this).parents('.js-struct-field').length > 0;
      if (isChildOfStruct) {
        return;
      }

      var list = yext.location.ReferenceValueList.field($(this));
      var locationField = _location.getField(list.$ctx.closest(context));

      $(list).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        list.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          list.set(response['field']);
          list.storeValue();
          locationField.$display
            .empty()
            .append(list.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize all address fields on the page, and then initialize known address fields
   */
  _location.initAddressFields = function(context, callback) {
    $('.js-entity-address-field').each(function() {
      new yext.location.Address($(this));
    });
    _location.initAddressField(context);
    _location.initCompoundAddress(context, callback);
  };

  /**
   * Initialize the compound address field (address + service area)
   */
  _location.initCompoundAddress = function(context, callback) {
    var $compoundAddress = $('.js-compound-address-edit', context);

    if ($compoundAddress.length) {
      var compoundAddress = new yext.entity.fields.CompoundAddress($compoundAddress);
      var locationField = _location.getField($compoundAddress.closest(context));

      $(compoundAddress).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        compoundAddress.reset();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          compoundAddress.set(response['field']);
          compoundAddress.storeValue();
          locationField.$display
            .empty()
            .append(compoundAddress.getDisplayValue());
        }
      });

      // Triggered by ungeocodable address dialog
      $(compoundAddress).on('submitField', function() {
        locationField.showDelayedProgressDialog();
        locationField.field.submit();
      });

      if (yext.isFunction(callback)) {
        // TODO SPR-511 (dlee): remove the conditional and keep the block when removing locationsstorm
        if ($('.js-entity-edit-page-info').length > 0) {
          var dataFetcher = function() {
            return compoundAddress.getDataForEntityVerification();
          };
          callback(locationField, locationField.fieldName, dataFetcher);
        }
      }
    }
  };

  /**
   * Initialize the standalone address field
   */
  _location.initAddressField = function(context) {
    var $address = $('.js-entity-address-standalone', context);

    if ($address.length) {
      var address = $address.data('address');
      var locationField = _location.getField($address.closest(context));

      locationField.$form.find('.js-cancel-edit').click(function() {
        address.reset();
      });

      $(address).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          address.set(response['field']);
          address.storeValue();
          locationField.$display
            .empty()
            .append(address.getDisplayValue());
        }
      });

      // Triggered by ungeocodable address dialog
      $(address).on('submitField', function() {
        locationField.showDelayedProgressDialog();
        locationField.field.submit();
      });
    }
  };

  /**
   * Initialize the event location field
   */
  _location.initEventLocation = function(context) {
    var $ctx = $('.js-event-location-field', context);

    if ($ctx.length) {
      var eventLocation = new yext.location.EventLocation($ctx);
      var locationField = _location.getField($ctx.closest(context));

      $(eventLocation).on('updated', function() {
        if (!eventLocation.isEmpty()) {
          locationField.field.enableSubmit();
        } else {
          locationField.field.disableSubmit();
        }
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        eventLocation.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          eventLocation.set(response['field']);
          eventLocation.storeValue();
          eventLocation.renderViewMode();
          eventLocation.updateMapMarker(response['field']);
        }
      });

      // Triggered by ungeocodable address dialog
      $(eventLocation).on('submitField', function() {
        locationField.showDelayedProgressDialog();
        locationField.field.submit();
      });
    }
  };

  /**
   * Initialize single date time style fields.
   */
  _location.initDateTime = function(context) {
    $('.js-date-time-field', context).each(function() {
      var dateTime = new yext.location.DateTime($(this));
      var locationField = _location.getField(dateTime.$ctx.closest(context));

      $(dateTime).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        dateTime.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          dateTime.set(response['field']);
          dateTime.storeValue();
          locationField.$display
            .empty()
            .append(dateTime.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize date time range style fields.
   */
  _location.initDateTimeRange = function(context) {
    $('.js-date-time-range-field', context).each(function() {
      var dateTimeRange = new yext.location.DateTimeRange($(this));
      var locationField = _location.getField(dateTimeRange.$ctx.closest(context));

      $(dateTimeRange).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        dateTimeRange.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          dateTimeRange.set(response['field']);
          dateTimeRange.storeValue();
          locationField.$display
            .empty()
            .append(dateTimeRange.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize option list style fields.
   */
  _location.initOptionList = function(context) {
    $('.js-option-list-field', context).each(function() {
      var isChildOfStruct = $(this).parents('.js-struct-field').length > 0;
      if (isChildOfStruct) {
        return;
      }

      var optionList = new yext.location.OptionList($(this));
      var locationField = _location.getField(optionList.$ctx.closest(context));

      $(optionList).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        optionList.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          optionList.set(response['field']);
          optionList.storeValue();
          locationField.$display
            .empty()
            .append(optionList.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize phone style fields.
   */
  _location.initPhone = function(context) {
    $('.js-phone-field', context).each(function() {
      var phone = new yext.location.Phone($(this));
      var locationField = _location.getField(phone.$ctx.closest(context));

      if (!locationField.$form.length) {
        // The field is in view only mode
        return;
      }

      $(phone).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        phone.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          phone.set(response['field']);
          phone.storeValue();
          locationField.$display
            .empty()
            .append(phone.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize reference value fields. Ex. Reference Location and Reference User
   */
  _location.initReferenceValue = function(context) {
    $('.js-standalone-reference-value-field', context).each(function() {
      var referenceValue = new yext.location.ReferenceValue($(this));
      var locationField = _location.getField(referenceValue.$ctx.closest(context));

      $(referenceValue).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        referenceValue.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          referenceValue.set(response['field']);
          referenceValue.storeValue();
          locationField.$display
            .empty()
            .append(referenceValue.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize image and image list fields
   *
   * NOTE(mattjs) This uses a new pattern we are setting for field initialization where all fields,
   * even as sub fields are initialized the same. Then the parent field, like ImageListField collects
   * the sub field objects from the DOM
   */
  _location.initImageFields = function(context) {
    $('.js-image-field', context).each(function() {
      var image = new yext.location.image.Image($(this));
    });

    _location.initImageField(context);
    _location.initImageListField(context);
  };

  /**
   * Initialize image type fields.
   */
  _location.initImageField = function(context) {
    $('.js-image-type-field', context).each(function() {
      var isChildOfStruct = $(this).parents('.js-struct-field').length > 0;
      if (isChildOfStruct) {
        return;
      }

      var imageField = new yext.location.image.ImageField($(this), {uploadUrl: ''});
      var locationField = _location.getField(imageField.$ctx.closest(context));

      $(imageField).on('updated', function() {
        locationField.field.enableSubmit();
        // For the empty case
        if (!imageField.$edit.is(':visible') && imageField.hasChanges()) {
          locationField.toggleEdit(true);
        }
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function(e) {
        imageField.reset();
        locationField.field.disableSubmit();
      });

      var imageFormSubmit = function(overrideUrl, additionalFormData, callback) {
        imageField.save(function(errorMessage, response) {
          // NOTE: Hack for custom goals and DAM
          if (yext.isFunction(callback)) {
            callback(errorMessage, response);
          } else if (response && response.actions) {
            locationField.field.handleResponse(response);
          } else if (!errorMessage) {
            locationField.$display.find('.js-image-field-view')
              .empty()
              .append(imageField.getDisplay());
            locationField.toggleEdit(false);
            locationField.field.disableSubmit();

            // Remove edit-state when this is an asset edit
            locationField.$row.closest('.js-content-data').toggleClass('edit-state');
          }
        }, overrideUrl, additionalFormData);
      };

      if (locationField.field) {
        // If a user doesn't have any way to edit an image, the field property will not exist
        locationField.field.submitForm = imageFormSubmit;
      }

      locationField.$form.on(
        'beforeSubmit.field',
        function(
          event,
          overrideUrl,
          additionalFormData = [],
          callback,
          internalData,
          preventFieldDefault = true) {
          if (locationField.field._preventDefault) {
            return;
          }
          preventFieldDefault && locationField.field.preventDefault();

          // Used to positively indicate that we want to cancel suggested edits on this submission
          if (internalData) {
            additionalFormData = additionalFormData.concat(internalData);
          }

          imageFormSubmit(overrideUrl, additionalFormData, callback);
        });

      $(imageField).on('saved', function(e, response) {
        locationField.processSaveResponse(response);
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        // For the empty case
        if (show && imageField.isEmpty()) {
          imageField.showAssetSelector();
          locationField.toggleEdit(false);
        }
      });
    });
  };

  /**
   * Initialize image list type fields
   * NOTE(mattjs) This replaces gallery fields
   */
  _location.initImageListField = function(context) {
    $('.js-image-list-field', context).each(function() {
      var imageListField = new yext.location.image.ImageListField($(this), {uploadUrl: ''});
      var locationField = _location.getField(imageListField.$ctx.closest(context));

      $(imageListField).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      $(imageListField).on('newImageFromAsset', function() {
        locationField.field.enableSubmit();
        // For the add first image case
        if (!imageListField.$field.is(':visible') && !imageListField.isEmpty()) {
          locationField.toggleEdit(true);
        }
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        imageListField.reset();
        locationField.field.disableSubmit();
      });

      // Don't allow normal form submit
      locationField.$form.on('beforeSubmit.field', function(event, overrideUrl, additionalFormData, callback) {
        locationField.field.preventDefault();
        imageListField.save(function(errorMessage, response) {
          // NOTE: Hack for custom goals and DAM
          if (yext.isFunction(callback)) {
            callback(errorMessage, response);
          } else if (!errorMessage) {
            locationField.$display.find('.js-image-list-field-view')
              .empty()
              .append(imageListField.getDisplay());
            locationField.toggleEdit(false);
            locationField.field.disableSubmit();
          }
        }, overrideUrl, additionalFormData);
      });

      $(imageListField).on('saved', function(e, response) {
        locationField.processSaveResponse(response);
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        // For the add first image case
        if (show && imageListField.isEmpty()) {
          imageListField.showAssetSelector();
          locationField.toggleEdit(false);
        }
      });
    });
  };

  /**
   * This is the internal initializer for all namedUrls
   *
   * @param {!Object} namedUrl The NamedUrl instance
   */
  _location.initInnerNamedUrl = function(namedUrl, context) {
    var locationField = _location.getField(namedUrl.$ctx.closest(context));

    $(namedUrl).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      namedUrl.reset();
      locationField.field.disableSubmit();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        namedUrl.set(response['field']);
        namedUrl.saveState();
        locationField.$display
          .empty()
          .append(namedUrl.getDisplayValue());
        locationField.field.disableSubmit();
      } else {
        namedUrl.reset();
      }
    });
  };

  /**
   * Initialize Special Offer fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initSpecialOffer = function(context) {
    $('.js-specialoffer-fields', context).each(function() {
      var specialOffer = new yext.location.SpecialOffer($(this));
      _location.initInnerNamedUrl(specialOffer, context);
    });
  };

  /**
   * Initialize fields of NamedUrlList type
   */
  _location.initNamedUrlList = function() {
    $('.js-named-url-list').each(function() {
      var urlList = new yext.location.NamedUrlList($(this));
      var locationField = _location.getField(urlList.$ctx.closest('tr'));

      $(urlList).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        urlList.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          urlList.set(response['field']);
          urlList.saveState();
          locationField.$display
            .empty()
            .append(urlList.getDisplayValue());
        }
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        if (show && urlList.isEmpty()) {
          urlList.addEmptyItem();
        }
      });
    });
  };

  /**
   * Bind ECL fields
   */
  _location.initECL = function(fieldSelector) {
    $('.js-enhanced-list-field').each(function() {
      var $row = fieldSelector ? $(this).closest(fieldSelector) : $(this).closest('tr');
      var ecl = new yext.location.ecl.EnhancedList($row);
      var locationField = _location.getField($row);

      locationField.$form.find('.js-cancel-edit').click(function() {
        ecl.reset();
        locationField.field.disableSubmit();
      });

      $(ecl).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          ecl.set(response['field']);
          ecl.saveState();
          ecl.renderDisplay();
        }
      });

      $(locationField).on('toggleFieldEdit', function() {
        // Hide tooltips when going from edit to display and vice versa
        window.hideContextualHelp();
      });
    });

    // Entity ECL fields
    $('.js-entity-enhanced-list-field').each(function() {
      var $row = fieldSelector ? $(this).closest(fieldSelector) : $(this).closest('tr');
      var ecl = new yext.entity.fields.ecl.EnhancedList($row);
      var locationField = _location.getField($row);

      locationField.$form.find('.js-cancel-edit').click(function() {
        ecl.reset();
        ecl.renderDisplay();
        locationField.field.disableSubmit();
      });

      $(ecl).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          ecl.set(response['field']);
          ecl.saveState();
          ecl.renderDisplay();
        }
      });

      $(locationField).on('toggleFieldEdit', function() {
        // Hide tooltips when going from edit to display and vice versa
        window.hideContextualHelp();
      });
    });
  };

  /**
   * Initialize all single select fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initSingleSelect = function(context) {
    $('.js-single-select-field', context).each(function() {
      var $this = $(this);
      var select = new yext.location.Select($this);
      var locationField = _location.getField($this.closest(context));
      var isChildOfStruct = $this.parents('.js-struct-edit').length > 0;

      if (locationField.fieldName === 'location.location_type' && !_location.isTemplate()) {
        _location.bindLocationTypeChange(select, locationField);
      }

      $(select).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        if (!isChildOfStruct) {
          select.reset();
        }
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field'] && !isChildOfStruct) {
          select.set(response['field']);
          select.storeValue();
          locationField.$display
            .empty()
            .append(select.getDisplayValue());
          if (locationField.fieldName === 'locationType' && _location.isTemplate()) {
            window.location.reload();
          }
          if (locationField.fieldName === 'virtual.entity_type') {
            yext.notify.showSuccess(yext.msg('Entity Type Updated! Refreshing the page to show new fields'));
            window.location.reload();
          }
        }
      });
    });
  };

  /**
   * Initialize all integer range select fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initIntegerRangeSelect = function(context) {
    $('.js-range-select-field', context).each(function() {
      var $this = $(this);
      var integerRange = new yext.location.IntegerRangeSelect($this);
      var locationField = _location.getField($this.closest(context));

      $(integerRange).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        integerRange.reset();
        locationField.field.disableSubmit();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          integerRange.set(response['field']);
          integerRange.storeValue();
          locationField.$display
            .empty()
            .append(integerRange.getDisplayValue());
        }
        locationField.field.disableSubmit();
      });
    });
  };

  /**
   * Initialize all entity label fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initEntityLabels = function(context) {
    $('.js-labels-edit', context).each(function() {
      var $this = $(this);
      var labels = new yext.location.EntityLabels($this);
      var locationField = _location.getField($this.closest(context));

      $(labels).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        labels.reset();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          labels.set(response['field']);
          labels.storeValue();
          locationField.$display
            .empty()
            .append(labels.getDisplayValue());
        }
      });
    });
  };

  /**
   * Initialize all youTubeVideo fields for entities
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initYouTubeVideoField = function(context, viewOnly) {
    $('.js-youTube-video-field', context).each(function() {
      var $this = $(this);
      var isChildOfStruct = $this.parents('.js-struct-field').length > 0;
      var isEditableChildOfStruct = $this.parents('.js-struct-edit').length > 0;

      if (isEditableChildOfStruct) {
        // If it is an editable child of struct, there is no need to create YouTubeVideoField.
        return;
      }

      if (viewOnly && $this.find('.emptyvalue').length) {
        // It's an empty field and we can't edit it, so don't do any js
        return;
      }

      var youTubeVideoField = new yext.entity.fields.video.YouTubeVideoField($this, viewOnly);
      var locationField = _location.getField($this.closest(context));

      if (viewOnly || isChildOfStruct) {
        // View only and we've done enough to load the video preview, so skip the rest
        return;
      }

      $(youTubeVideoField).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      $(youTubeVideoField).on('newVideoFromAsset', function() {
        locationField.field.enableSubmit();
        if (!youTubeVideoField.$edit.is(':visible') && youTubeVideoField.hasChanges()) {
          locationField.toggleEdit(true);
        }
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        youTubeVideoField.reset();
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        // For the empty case
        if (show && youTubeVideoField.isEmpty()) {
          youTubeVideoField.showAssetSelector();
          locationField.toggleEdit(false);
        }
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          youTubeVideoField.setFromResponse(response['field'], function() {
            youTubeVideoField.storeValue();
            locationField.toggleEdit(false);
            locationField.field.disableSubmit();
          });
        }
      });
    });
  };

  /**
   * Initialize video list type fields
   */
  _location.initYouTubeVideoListField = function(context, viewOnly) {
    $('.js-youTube-video-list-field', context).each(function() {
      var $this = $(this);

      if (viewOnly && $this.find('.emptyvalue').length) {
        // It's an empty field and we can't edit it, so don't do any js
        return;
      }

      var youTubeVideoListField = new yext.entity.fields.video.YouTubeVideoListField($this, viewOnly);
      var locationField = _location.getField($this.closest(context));

      if (viewOnly) {
        // View only and we've done enough to load the video preview, so skip the rest
        return;
      }

      $(youTubeVideoListField).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      $(youTubeVideoListField).on('newVideoFromAsset', function() {
        locationField.field.enableSubmit();
        // For the add first video case
        if (!youTubeVideoListField.$edit.is(':visible') && !youTubeVideoListField.isEmpty()) {
          locationField.toggleEdit(true);
        }
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        youTubeVideoListField.reset();
        locationField.field.disableSubmit();
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        // For the empty case
        if (show && youTubeVideoListField.isEmpty()) {
          youTubeVideoListField.showAssetSelector();
          locationField.toggleEdit(false);
        }
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          youTubeVideoListField.setFromResponse(response['field']);
          youTubeVideoListField.storeValue();
        }
      });
    });
  };

  /**
   * Initialize all number fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initNumber = function(context) {
    $('.js-number-field', context).each(function() {
      var $this = $(this);
      var number = new yext.location.Number($this);
      var locationField = _location.getField($this.closest(context));
      var isChildOfStruct = $this.parents('.js-struct-edit').length > 0;

      $(number).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        if (!isChildOfStruct) {
          number.reset();
        }
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field'] && !isChildOfStruct) {
          number.set(response['field']);
          number.storeValue();
          locationField.$display
            .empty()
            .append(number.getDisplayValue());
        }
      });
    });
  };

  /**
   * Construct the Map Marker field
   */
  _location.initMapMarker = function(context) {
    var $ctx = $(context).find('.js-map-marker');

    if (!$ctx.length) {
      return;
    }

    var locationField = _location.getField($ctx.closest(context));

    // If the field doesn't actually contain map marker data (e.g. in bulk edit), don't initialize
    // MapMarkerView object.
    if (!$ctx.data('field')) {
      return;
    }

    var marker = new yext.location.MapMarkerView($ctx);

    var $row = $ctx.closest('.virtual-map_marker');
    if (!$row.hasClass('no-edit')) {
      marker.bindEditTarget($row);
      $(marker).on('saved', function(e, response) {
        locationField.processSaveResponse(response);
      });

      if (marker.viewOnly) {
        $row.addClass('no-hover');
      }

      $ctx.on('eventLocationUpdated', function(e, data) {
        var viewOnly = Boolean(data['viewOnly']);
        $row.toggleClass('no-hover', viewOnly);
      });
    }
  };

  /**
   * Bind google attribute groups
   */
  _location.initGoogleAttributes = function() {
    var $section = $('#section-gmb_attributes, .js-google-attributes-section');

    $('.js-google-attribute-group').each(function() {
      var group = new yext.location.GoogleAttributeGroup($(this));
      var locationField = _location.getField(group.$ctx.closest('tr'));
      $(group).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        group.reset();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          group.set(response['field']);
          group.storeValue();
          locationField.$display
            .empty()
            .append(group.getDisplayValue());
        }
      });
    });

    if ($('.js-google-attribute-group').length) {
      $(yext.location.events).on('categoryFieldSaved', function() {
        // In entity edit, we force a refresh instead of updating the groups
        if (!$('.js-google-attributes-group-template').length) {
          yext.notify.showSuccess(yext.msg('Success! Refreshing the page to update available attributes'));
          window.location.reload();
        }
      });
    }
  };

  /**
   * Construct the websites field
   *
   * @param {string} context Parent selector context for 'row'
   */
  _location.initWebsites = function(context) {
    var $websites = $('.js-websites-field', context);

    if (!$websites.length) {
      return; // Early exit
    }

    var websites = new yext.location.Websites($websites);
    var locationField = _location.getField($websites.closest(context));

    $(websites).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      websites.reset();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        websites.set(response['field']);
        websites.storeValue();
        locationField.$display
          .empty()
          .append(websites.getDisplayValue());
      }
    });
  };

  _location.initUberTripBranding = function(context) {
    var $uberTripBranding = $('.js-uber-trip-branding', context);

    if ($uberTripBranding.length === 0) {
      return;
    }

    var branding = new yext.location.UberTripBranding($uberTripBranding);
    var locationField = _location.getField($uberTripBranding.closest(context));

    $(branding).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      branding.reset();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        branding.set(response['field']);
        branding.saveState();
        locationField.$display
          .empty()
          .append(branding.getDisplayValue());
      }
    });
  };

  /**
   * Initialize list style fields by constructing field objects and hooking up
   * location edit interactions
   * @param {string} context Selector for the context of the field
   */
  _location.initListFields = function(context) {
    $('.js-list-field-context', context).each(function() {
      var $this = $(this);
      var list = new yext.location.List($this);
      var locationField = _location.getField($this.closest(context));

      $(list).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      // View only
      if (!locationField.$form.length) {
        return;
      }

      locationField.$form.find('.js-cancel-edit').click(function() {
        list.reset();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field']) {
          list.set(response['field']);
          list.storeValue();
          locationField.$display
            .empty()
            .append(list.getDisplayValue());
        }
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        if (show && list.isEmpty() && !list.isElidedMode()) {
          list.addEmptyItem();
        }
      });

      if (locationField.fieldName.substring(0, 15) === 'location.custom') {
        $(yext.location.events).on('customFieldTimestampUpdated', function(e, data) {
          list.model.set({
            timestamp: data,
          });
        });
      }
    });
  };

  /**
   * @return {boolean}
   */
  _location.isTemplate = function() {
    return location.pathname.indexOf('template') != -1;
  };

  /**
   * @return {number}
   */
  _location.getTemplateId = function() {
    return parseInt(location.pathname.replace(/^.+template\//, ''));
  };

  /**
   * Handle the location type being updated which uses a dialog to collect
   * additional location information before submitting the field
   *
   * @param {Select} select Location type module
   * @param {LocationField} locationField Location type location field object
   * @param {string} initialValue string representing original value of select
   */
  _location.bindLocationTypeChange = function(select, locationField) {
    var updater = new yext.location.LocationTypeUpdater($('.js-location-type-updater'));
    var initialValue = select.getValue();
    locationField.$form.on('beforeSubmit.field', function() {
      locationField.field.preventDefault();
      updater.show({
        updatedValue: select.getValue(),
        updatedLabel: select.getLabel(),
        initialValue: initialValue,
        timestamp: locationField.$form.find('.js-field-timestamp').val(),
        successCallback: function() {
          yext.notify.showSuccess(yext.msg('Location type updated succesfully. The page will refresh shortly.'));
          setTimeout(function() {
            window.location = window.location;
          }, 1000);
        },
      });
    });
    $(updater).on('typeChanged', function() {
      locationField.toggleEdit(false);
    });
  };

  /**
   * Initialize all date fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initDate = function(context) {
    $('.js-date-field', context).each(function() {
      var $ctx = $(this).closest(context);
      var date = new yext.location.Date($(this));
      var locationField = _location.getField(date.$ctx.closest(context));
      var isChildOfStruct = $(this).parents('.js-struct-edit').length > 0;

      $(date).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field'] && !isChildOfStruct) {
          date.set(response.field);
          date.storeValue();
          locationField.$display
            .empty()
            .append(date.getDisplayValue());
        }
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        if (!isChildOfStruct) {
          date.reset();
        }
      });
    });
  };


  /**
   * Initialize all rich text fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initRichText = function(context) {
    $('.js-rich-text-field', context).each(function() {
      var $ctx = $(this).closest(context);
      var richText = new yext.location.RichText($(this));
      var locationField = _location.getField(richText.$ctx.closest(context));
      var isChildOfStruct = $(this).parents('.js-struct-edit').length > 0;

      $(richText).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (response['field'] && !isChildOfStruct) {
          richText.set(response.field);
          richText.storeValue(locationField.$display);
        }
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        if (!isChildOfStruct) {
          richText.reset();
        }
      });
    });
  };

  /**
    * Initialize all location fields
    *
    * @param {string} context Selector for the context of the field
    */
  _location.initLocationField = function(context) {
    $('.js-location-field', context).each(function() {
      var location = new yext.location.Location($(this));
      var locationField = _location.getField(location.$ctx.closest(context));

      $(location).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(_, response) {
        if (response['field']) {
          location.set({value: JSON.stringify(response.field)});
          location.storeValue(locationField.$display);
        }
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        location.reset();
      });
    });
  };

  /**
   * Initialize all multiple select fields
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initMultipleSelect = function(context) {
    $('.js-multiple-select-field', context).each(function() {
      var $ctx = $(this).closest(context);
      var select = new yext.location.MultipleSelect($ctx);
      _location.initMultipleSelectInternal(select);
    });

    $('.js-searchable-multiple-select-field', context).each(function() {
      var $ctx = $(this).closest(context);
      var select = new yext.location.SearchableMultipleSelect($ctx);
      _location.initMultipleSelectInternal(select);
    });
  };


  /**
   * Supports regular and searchable multipleselect fields
   *
   * @param {MultipleSelect} select Instance of class that extends MultipleSelect
   */
  _location.initMultipleSelectInternal = function(select) {
    var locationField = _location.getField(select.$ctx);

    $(select).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        select.set(response.field);
        select.storeValue();
        locationField.$display
          .empty()
          .append(select.getDisplayValue());
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      select.reset();
    });
  };

  /**
   * Initializing Healthcare Name Field
   * @param {string} context Selector for the context of the field
   */
  _location.initHealthcareName = function(context) {
    var $row = $('.js-healthcare-name-edit', context).closest(context);

    if ($row.length <= 0) {
      return;
    }

    var healthcareName = new yext.location.HealthcareName($row);
    var healthcareField = _location.getField($row);

    $(healthcareName).on('updated', function() {
      healthcareField.field.enableSubmit();
    });

    healthcareField.$form.find('.js-cancel-edit').click(function() {
      healthcareName.reset();
      healthcareField.field.disableSubmit();
    });

    healthcareField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        healthcareName.set(response['field']);
        healthcareName.storeValue();
        healthcareField.$display
          .empty()
          .append(healthcareName.getDisplayValue());
      }
    });
  };

  /**
   * Initialize education field
   */
  _location.initEducation = function() {
    var $this = $('.js-education-field');

    if ($this.length <= 0) {
      return;
    }

    var education = new yext.location.Education($this);
    var locationField = _location.getField($this.closest('tr'));

    $(education).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.on('beforeSubmit.field', function() {
      locationField.field.additionalData = [{
        name: locationField.fieldName,
        value: education.getJSONData(),
      }];
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        education.set(response['field']);
        education.storeValue();
        locationField.$display
          .empty()
          .append(education.getDisplayValue());
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      education.reset();
      locationField.field.disableSubmit();
    });
  };

  /**
   * Initialize Facebook cta field
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initFacebookCta = function(context) {
    var $this = $('.js-facebook-cta-field', context);
    if ($this.length <= 0) {
      return;
    }

    var facebookCta = new yext.location.FacebookCta($this);
    var locationField = _location.getField($this.closest(context));

    $(facebookCta).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.on('beforeSubmit.field', function() {
      locationField.field.additionalData = [{
        name: locationField.fieldName,
        value: facebookCta.getJSONData(),
      }];
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        facebookCta.set(response['field']);
        facebookCta.storeValue();
        locationField.$display
          .empty()
          .append(facebookCta.getDisplayValue());
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      facebookCta.reset();
      locationField.field.disableSubmit();
    });
  };

  /**
   * Create simple text fields
   */
  _location.simpleTextFields = function(context, cb, shouldBindFormOnEdit) {
    // TODO(mattjs) Consolidate these selectors
    $('.js-field-simple-text, .js-simple-text-field', context).each(function() {
      var locationField = _location.getField($(this).closest(context));
      var isChildOfStructOrGenericList = $(this).parents('.js-struct-edit').length > 0
                                         || $(this).parents('.js-generic-list-edit').length > 0;
      var fieldId = locationField.fieldName;

      let initialized = false;
      var initializeForm = () => {
        if (initialized) return;
        initialized = true;

        // NOTE(schakraborty): Changing the field id so that the usageType below is set based on the id of the sub-field.
        if (fieldId == 'virtual.name') {
          fieldId = 'location.business_name';
        }
        var usageType = goog.module.get('yext.dam.assetselector.usage').forProfileFields(fieldId);
        var $textField = $(this).find('.js-text-field');
        var textField = yext.textfield.create(
          $textField,
          locationField.fieldName,
          locationField.customFieldId,
          locationField.isSuggestEditMode, usageType);

        $(textField).on('update.textField', function() {
          if (textField.required && !textField.value().trim()) {
            locationField.field.disableSubmit();
          } else {
            locationField.field.enableSubmit();
          }
          _location.fieldUpdated();
        });

        if (locationField.isSuggestEditMode) {
          $(textField).on('assetselected.textField', function() {
            locationField.updateSubmitButtonText('alt-text1');
          });

          $(textField).on('removeasset.textField', function() {
            locationField.updateSubmitButtonText('default-text');
          });
        }

        locationField.$form.find('.js-cancel-edit').click(function() {
          if (!isChildOfStructOrGenericList) {
            textField.reset();
            locationField.field.disableSubmit();
            if (locationField.isSuggestEditMode) {
              locationField.updateSubmitButtonText('default-text');
            }
          }
        });

        /**
         * NOTE(blin): Leave social media handles unescaped so that hyperlinks work.
         * These fields already check for valid input, preventing injected JavaScript from executing.
         */
        locationField.$form.on('save.field', function(e, response) {
          if (!response.error && !isChildOfStructOrGenericList) {
            if (response.field) {
              textField.set(response.field);
              textField.saveValue();
              var shouldEscape = _location.LocationField.UNESCAPED_FIELD_NAMES.indexOf(locationField.fieldName) == -1;
              locationField.$display.html(textField.viewMarkup(shouldEscape));
            } else {
              // If no field was sent in the response, this was a suggested edit
              textField.reset();
            }
            locationField.field.disableSubmit();
          }
        });

        if (yext.isFunction(cb)) {
          // TODO SPR-511 (dlee): remove the conditional and the else case when removing locationsstorm
          if ($('.js-entity-edit-page-info').length > 0) {
            var dataFetcher = function() {
              return {'name': textField.value()};
            };
            cb(locationField, locationField.fieldName, dataFetcher);
          } else {
            cb(locationField, textField);
          }
        }
      };

      if (shouldBindFormOnEdit) {
        $(locationField).on('toggleFieldEdit', initializeForm);
      } else {
        initializeForm();
      }
    });
  };

  /**
   * Initialize Facebook cover and profile photo
   */
  _location.initFacebookFields = function(context, $viewSelector) {
    var $fields = $('.js-facebook-photo-fields', context);
    if ($fields.length) {
      var isSuggestEditMode = $fields.closest(context).data('suggestEditMode');
      new yext.location.facebook.ViewController('location.facebook_profile_photo', $viewSelector, isSuggestEditMode);
      new yext.location.facebook.ViewController('location.facebook_cover_photo', $viewSelector, isSuggestEditMode);
    }
  };

  /**
   * Initialize other fields like phones and payment options
   */
  _location.initOldStyleFields = function(context) {
    // Event hooks
    $(context).delegate('tbody tr', 'mouseover', function() {
      var $this = $(this);
      var $parent = $this.closest(context);

      if ($this.hasClass('no-hover') || $parent.hasClass('no-hover')) {
        return;
      }

      $(context + ' .profile-row-hover').removeClass('profile-row-hover');
      $this.addClass('profile-row-hover');
    }).delegate('tbody tr', 'mouseout', function() {
      $(this).removeClass('profile-row-hover');
    }).delegate('tbody tr', 'click', function(e) {
      var $row = $(this);
      var event = $.event.fix(e);
      if ($row.hasClass('no-edit')
          || $(event.target).hasClass('no-edit')
          || $row.hasClass('profile-row-edit')
          || $row.find('.field-display').length === 0
          || !$row.parents().hasClass('edit')
          || $row.closest('.js-suggested-content').hasClass('no-edit')) {
        return true;
      }
      event.stopPropagation();
      event.preventDefault();
      $row.find('.field-display').click();
      return false;
    }).delegate('.field-edit-form .reset', 'click', function() {
      $(this).parents('form')[0].reset();
      $(document).trigger('click.selectbox');
      return false;
    }).delegate('.submit', 'click', function() {
      submit($(this));
    });
  };

  /**
   * Initialize external url module
   */
  _location.initExternalUrl = function(context) {
    $('.js-externalurl-fields', context).each(function() {
      var locationField = yext.location.getField($(this).closest(context));
      var view = new yext.location.externalurl.ViewController($(this), locationField.isSuggestEditMode);

      $(view).on('update.externalUrl', function() {
        locationField.field.enableSubmit();
        locationField.hideAllErrors();
      });

      $(locationField.$form).on('save.field', function(e, response) {
        if (!response.error) {
          if (response.field != null) {
            view.reconcile(response.field);
            locationField.$display.empty().append(view.viewMarkup());
          } else {
            view.reset();
          }
        }
      });

      locationField.$edit.find('.js-cancel-edit').click(function() {
        view.reset();
      });

      $(view).on('update.externalUrl', function() {
        _location.fieldUpdated();
      });
    });
  };

  /**
   * Initialize gallery module
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initGallery = function(context) {
    yext.location.gallery.browse.init();
    $('.js-gallery-fields', context).each(function() {
      var $this = $(this);
      var locationField = yext.location.getField($this.closest(context));
      var gallery = yext.location.gallery.create($this.closest('.js-gallery-cell'), context, locationField.isSuggestEditMode);

      // For headshot
      if (yext.locationcluster.shouldShowWarningDialog(locationField.fieldName)) {
        new yext.locationcluster.ClusterGuard(locationField.field);
      }

      gallery.locationEditFeatures(locationField);
      $(gallery).on('update.gallery', function() {
        _location.fieldUpdated();
      });
    });
    if ($('.js-preview-gallery').length) {
      _location.galleryViewOnly();
    }
  };

  /**
   * Setup browse gallery dialog
   */
  _location.galleryViewOnly = function() {
    $('.js-gallery-cell').each(function() {
      var $photos = $(this).find('.js-preview-gallery .js-gallery-display-photo');

      if ($photos.length) {
        var photos = [];

        $photos.each(function() {
          var $this = $(this);

          var assetData = $this.data('asset-data');
          var description = assetData ? assetData : $this.data('description');
          var url = $this.data('url');

          photos.push({
            description: description,
            url: url,
          });

          $this.click(function() {
            yext.location.gallery.browse.showGallery(photos, url);
          });
        });
      }
    });
  };

  /**
   * Initialize youtube module
   */
  _location.initVideo = function(context) {
    $('.js-single-video-field', context).each(function() {
      var $this = $(this);
      var locationField = yext.location.getField($this.closest(context));
      var video = new yext.location.video.VideoController($this, context, locationField);
      video.locationEditFeatures();
      $(video).on('updated.video', function() {
        _location.fieldUpdated();
      });
    });
  };

  /**
   * Initialize youtube gallery module
   */
  _location.initVideoGallery = function(context) {
    $('.js-video-list-field', context).each(function() {
      var $this = $(this);
      var locationField = yext.location.getField($this.closest(context));
      var videoGallery = new yext.location.VideoGalleryView($this, context, locationField);
      videoGallery.locationEditFeatures();
      $(videoGallery).on('update.video', function() {
        _location.fieldUpdated();
      });
    });
  };

  /**
   * Initialize struct fields
   */
  _location.initStruct = function(context, shouldBindFormOnEdit) {
    $('.js-struct-edit', context).each(function() {
      var $field = $(this);
      var locationField = _location.getField($field.closest(context));
      var $children = $field.find('.js-struct-child').first().siblings('.js-struct-child').addBack();
      var isChildOfStruct = $field.parents('.js-struct-edit').length > 0;
      var isGenericListItem = $field.parents('.js-generic-list-edit').length > 0;

      // Note: struct construction will be handled by the top level struct
      if (isChildOfStruct || isGenericListItem) {
        return;
      }

      var initialized = false;
      var initializeForm = () => {
        if (initialized) return;
        initialized = true;

        var struct = new yext.location.Struct($(this), context);

        locationField.$form.find('.js-cancel-edit').click(function() {
          if (!isChildOfStruct) {
            struct.reset();
          }
        });

        locationField.$form.on('beforeSubmit.field', function() {
          struct.reconcileAsset();
          locationField.field.files = struct.orderAndAssociateImageFiles();
        });

        $(struct).on('updated nonAssetClearingUpdate', function() {
          locationField.field.enableSubmit();
        });

        locationField.$form.on('save.field', function(e, response) {
          if (!response.error && response.field && !isChildOfStruct) {
            struct.afterSave(response);
          }
        });
      };
      if (shouldBindFormOnEdit) {
        $(locationField).on('toggleFieldEdit', initializeForm);
      } else {
        initializeForm();
      }
    });
  };

  /**
   * Initialize list fields
   */
  _location.initList = function(context, shouldBindFormOnEdit) {
    $('.js-generic-list-edit', context).each(function() {
      let $field = $(this);
      let locationField = _location.getField($field.closest(context));
      let isChildOfStruct = $field.parents('.js-struct-edit').length > 0;

      if (isChildOfStruct) {
        return;
      }

      var initialized = false;
      var initializeForm = () => {
        if (initialized) return;
        initialized = true;

        let list = new yext.location.GenericList($field, context);
        locationField.$form.find('.js-cancel-edit').click(() => list.reset());
        $(list).on('updated nonAssetClearingUpdate', () => locationField.field.enableSubmit());

        locationField.$form.on('beforeSubmit.field', function() {
          list.reconcileAsset();
          locationField.field.files = list.orderAndAssociateImageFiles();
        });

        locationField.$form.on('save.field', function(e, response) {
          if (!response.error && response.field) {
            list.afterSave(response);
          }
        });
      };

      if (shouldBindFormOnEdit) {
        $(locationField).on('toggleFieldEdit', initializeForm);
      } else {
        initializeForm();
      }
    });
  };

  /**
   * Initialize hours fields
   */
  _location.initHours = function(context, afterSaveRender) {
    $('.js-hours-edit', context).each(function() {
      var $field = $(this);
      var isChildOfStruct = $field.parents('.js-struct-edit').length > 0;
      var isChildOfList = $field.parents('.js-generic-list-item').length > 0;

      // don't initialize original content on approvals page
      if ($field.length == 0 || isChildOfStruct || isChildOfList) {
        return;
      }

      var dayHours = new yext.location.hours.DayHours($(this), context);
      var locationField = _location.getField($field.closest(context));
      var holidayHoursLocationField;

      if (dayHours.holidayHours) {
        holidayHoursLocationField = _location.getField(dayHours.holidayHours.$element.closest(context));
        dayHours.holidayHours.setDisplay(holidayHoursLocationField.$display);
      }

      $(dayHours).on('updated.hours', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        dayHours.reset();
      });

      /**
       * Get additional data to be sent with the field
       *
       * @return {!Object} Hours field additional data
       */
      var getAdditionalData = function() {
        return [{
          name: dayHours.fieldName + '.timestamp',
          value: dayHours.getTimestamp(),
        }, {
          name: dayHours.fieldName + '.specified',
          value: dayHours.hoursSpecified,
        }];
      };

      /**
       * After save, reconcile with backend and store values, render display mode
       *
       * @param {!Object} response Server response from save
       */
      var afterSave = function(response) {
        // Update so that either field updates the value
        locationField.updateTimestamp(response.field.timestamp);
        dayHours.reconcile(response.field);
        dayHours.storeValues();

        if (yext.isFunction(afterSaveRender)) {
          afterSaveRender(response, locationField.$display, dayHours);
        } else {
          locationField.$display
            .empty()
            .append(dayHours.generateViewMarkup());
          if (dayHours.holidayHours) {
            holidayHoursLocationField.$display
              .empty()
              .append(dayHours.holidayHours
                .generateViewMarkup(!dayHours.hoursSpecified && !dayHours.indeterminate));
          }
        }
      };

      locationField.$form.on('beforeSubmit.field', function() {
        locationField.field.additionalData = $.merge(locationField.field.additionalData, getAdditionalData());
      });

      locationField.$form.on('save.field', function(e, response) {
        if (!response.error && response.field) {
          afterSave(response);
        }
      });

      $(locationField).on('toggleFieldEdit', function(e, show) {
        if (show && !dayHours.$hoursSpecified.prop('checked')) {
          dayHours.$hoursSpecified.click();
        }
      });

      if (dayHours.holidayHours) {
        $(dayHours.holidayHours).on('updated.holidayHours', function() {
          holidayHoursLocationField.field.enableSubmit();
          _location.fieldUpdated();
        });

        // In case of the hours holiday hours grouped view
        if (locationField !== holidayHoursLocationField) {
          holidayHoursLocationField.$form.find('.js-cancel-edit').click(function() {
            dayHours.holidayHours.reset();
          });

          holidayHoursLocationField.$form.on('beforeSubmit.field', function() {
            holidayHoursLocationField.field.additionalData = $.merge(holidayHoursLocationField.field.additionalData, getAdditionalData());
          });

          holidayHoursLocationField.$form.on('save.field', function(e, response) {
            if (!response.error && response.field) {
              afterSave(response);
            }
          });
        }

        // Add an empty hour if there are not any to make using this a bit easier, only in entity/location edit
        $(holidayHoursLocationField).on('toggleFieldEdit', function(e, show) {
          if (show && !dayHours.holidayHours.hours.length && dayHours.fieldName.startsWith('virtual.')) {
            dayHours.holidayHours.addEmptyHour();
          }
        });
      }
    });
  };

  /**
   * Initialize custom field daily times
   */
  _location.initTimes = function(context) {
    $('.js-times-edit', context).each(function() {
      var dailyTimes = yext.location.custom.times.daily.create($(this));
      var locationField = _location.getField($(this).closest(context));
      var holidayTimesLocationField;

      if (dailyTimes.holidayTimes) {
        holidayTimesLocationField = _location.getField(dailyTimes.holidayTimes.$element.closest(context));
        dailyTimes.holidayTimes.setDisplay(holidayTimesLocationField.$display);
      }

      /**
       * Get additional data to be sent with the field
       *
       * @return {!Object} Daily times field data
       */
      var getAdditionalData = function() {
        return [{
          name: dailyTimes.fieldName,
          value: yext.JSON.stringify(dailyTimes.get()),
        }];
      };

      /**
       * After save, reconcile with backend and store values, render display mode
       *
       * @param {!Object} response Server response from save
       */
      var afterSave = function(response) {
        // Update so that either field updates the value
        locationField.updateTimestamp(response.field.timestamp);
        dailyTimes.reconcile(response.field);
        dailyTimes.storeValues();
        locationField.$display
          .empty()
          .append(dailyTimes.generateViewMarkup());
        if (dailyTimes.holidayTimes) {
          holidayTimesLocationField.$display
            .empty()
            .append(dailyTimes.holidayTimes
              .generateViewMarkup(!dailyTimes.timesSpecified));
        }
      };

      locationField.$form.on('beforeSubmit.field', function() {
        locationField.field.additionalData = getAdditionalData();
      });

      locationField.$form.on('save.field', function(e, response) {
        if (!response.error && response.field) {
          afterSave(response);
        }
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        dailyTimes.reset();
      });

      $(dailyTimes).on('updated.dailyTimes', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      if (dailyTimes.holidayTimes) {
        $(dailyTimes.holidayTimes).on('updated.holidayTimes', function() {
          holidayTimesLocationField.field.enableSubmit();
          _location.fieldUpdated();
        });

        holidayTimesLocationField.$form.on('beforeSubmit.field', function() {
          var data = getAdditionalData();

          data = data.concat([{
            name: dailyTimes.fieldName + '.timestamp',
            value: dailyTimes.getTimestamp(),
          }, {
            name: dailyTimes.fieldName + '.specified',
            value: dailyTimes.timesSpecified,
          }]);

          holidayTimesLocationField.field.additionalData = data;
        });

        holidayTimesLocationField.$form.on('save.field', function(e, response) {
          if (!response.error && response.field) {
            afterSave(response);
          }
        });

        holidayTimesLocationField.$form.find('.js-cancel-edit').click(function() {
          dailyTimes.holidayTimes.reset();
        });
      }

      $(locationField).on('toggleFieldEdit', function(e, show) {
        if (show && !dailyTimes.$specifyTimes.prop('checked')) {
          dailyTimes.$specifyTimes.click();
        }
      });
    });
  };

  /**
   * Bind category field
   */
  _location.initCategories = function() {
    var $row = $('.location-categories');

    if ($row.length && $row.find('.js-categories-field').length) {
      var categoryField = new yext.location.categories.CategoryField($row);

      var locationField = _location.getField($row);
      var maxListSize = categoryField.baseCategories.getMaxListSize();

      locationField.field.setValidator(function() {
        if (categoryField.baseCategories.getCheckedShownCategories().length > maxListSize) {
          return confirm(yext.msgn(
            'Warning: This update may result in locations with more than 1 category. ' +
            'Only the first category will be saved in this case.',
            'Warning: This update may result in locations with more than {0} categories. ' +
            'Only the first {0} categories will be saved in this case.',
            maxListSize));
        }
        return true;
      });

      $(categoryField).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      // Bind the cluster warning dialog
      new yext.locationcluster.ClusterGuard(locationField.field);

      locationField.$form.on('beforeSubmit.field', function() {
        if (!_location.isTemplate()) {
          locationField.field.preventDefault();
          new yext.location.categories.CategoriesWarningDialog(function() {
            locationField.field.submit();
          }, function() {
            categoryField.reset();
            locationField.toggleEdit(false);
          });
        }
      });

      locationField.$form.on('save.field', function(e, response) {
        if (!response.error) {
          if (response.suggestedEditIds) {
            categoryField.reset();
          } else {
            categoryField.reconcile(response.field);
            categoryField.storeValues();
            _location.updateKeywords(response.keywords);
            locationField.updateTimestamp(response.field.timestamp);
            categoryField.baseCategories.renderViewMode();
            $(yext.location.events).trigger('categoryFieldSaved');
          }
        }
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        categoryField.reset();
      });
    }
  };

  /**
   * Update keyword fields upon changing the category field.
   *
   * @param {!Array} keywords the list of new keywords sections
   */
  _location.updateKeywords = function(keywords) {
    // NOTE (yliu): Currenlty entity edit page doesn't have keywords field.
    if (keywords) {
      var sectionById = _location.keywordSections.reduce(function(a, v) {
        a[v.model.id] = v;
        return a;
      }, {});

      keywords.forEach(function(updatedSection) {
        var section = sectionById[updatedSection.id];
        if (section) {
          section.render(updatedSection.html);
          section.fields.forEach(_location.configureKeywordField);
        }
      });

      _location.initOldStyleFields('.js-keywords-section > .profile-table');
    }
  };


  /**
   * Bind keywords field
   */
  _location.initKeywords = function() {
    var sections = [];
    $('.js-keywords-section').each(function() {
      var section = new yext.location.keywords.KeywordSection($(this));
      sections.push(section);
    });

    sections.forEach(function(section) {
      section.fields.forEach(_location.configureKeywordField);
    });

    _location.keywordSections = sections;
  };

  /** Sets up the bindings between a KeywordsField and its LocationField. */
  _location.configureKeywordField = function(keywordsField) {
    var $fieldRow = keywordsField.$element.closest('tr');
    var locationField = _location.getField($fieldRow);
    if (!locationField) {
      locationField = new _location.LocationField($fieldRow);
    }

    $(keywordsField).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.field.setValidator(function() {
      return keywordsField.validateSubmit();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (!response.stale) {
        var $view = keywordsField.renderViewMode(response);
        locationField.$display.empty().append($view);
      } else {
        locationField.field.enableSubmit();
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      keywordsField.reset();
    });
  };

  /**
   * Bind labels field.
   */
  _location.initLabels = function() {
    $('.js-location-labels').each(function() {
      var $this = $(this);
      var view = yext.location.labels.createFieldView(
        $this,
        yext.location.getField($this.closest('tr')));
      $(view).on('update.labels', function() {
        _location.fieldUpdated();
      });
    });
  };

  /**
   * Initialize GMB fields
   */
  _location.initGMB = function() {
    if (yext.gmb.hasCoverPhotoSection()) {
      var coverPhotoView = yext.gmb.newGoogleCoverPhotoView({uploadUrl: ''});
      $(coverPhotoView).on('updated', function() {
        yext.location.helpers.hideError(coverPhotoView.$ctx);
      });
      $(coverPhotoView).on('error', function(e, message) {
        yext.location.helpers.showError(message, coverPhotoView.$ctx);
      });
    }

    if (yext.gmb.hasProfilePhotoSection()) {
      var profilePhotoView = yext.gmb.newGoogleProfilePhotoView({uploadUrl: ''});
      $(profilePhotoView).on('updated', function() {
        yext.location.helpers.hideError(profilePhotoView.$ctx);
      });
      $(profilePhotoView).on('error', function(e, message) {
        yext.location.helpers.showError(message, profilePhotoView.$ctx);
      });
    }
  };

  /**
   * Initialize Google Relationship Field
   */
  _location.initGoogleRelationship = function() {
    $('.js-google-relationship').each(function() {
      var $this = $(this);
      var locationField = _location.getField($this.closest('tr'));
      var view = new yext.location.GoogleRelationship($this, locationField.$display);

      locationField.$form.find('.js-cancel-edit').click(function() {
        locationField.field.disableSubmit();
        view.reset();
      });

      $(view).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        view.updateEditViewFromResponse(response);
        view.updateDisplayViewFromResponse(response);
      });
    });
  };

  /**
   * Initialize gas station features fields
   */
  _location.initGasStationFeatures = function() {
    $('.js-gas-station-features').each(function() {
      var view = new yext.location.GasStationFeaturesView($(this));
      var locationField = _location.getField($(this).closest('tr'));

      $(view).on('update', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        view.model = new yext.location.GasStationFeatures(
          response['field']['allGasStationFeatureViews']);
        view.renderViewMode();
        view.renderEditMode();
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        view.reset();
      });
    });
  };

  /**
   * Bind radio fields
   */
  _location.initRadio = function() {
    $('.js-radio-content').each(function() {
      var radioField = _location.radio.create($(this));
      var locationField = _location.getField($(this).closest('tr'));

      $(radioField).on('updated', function() {
        locationField.field.enableSubmit();
        _location.fieldUpdated();
      });

      locationField.$form.on('save.field', function(e, response) {
        radioField.updateDataModel(response);
      });

      locationField.$form.find('.js-cancel-edit').click(function() {
        radioField.reset();
      });
    });
  };

  /**
   * initialize the Uber Tracking Link
   */
  _location.initUberLaunchLink = function(context) {
    var $uberLaunchLink = $('.js-uber-launch-link', context);
    var $uberEmbedLink = $('.js-uber-embed-link', context);

    if ($uberLaunchLink.length <= 0) {
      return;
    }

    var uberLaunchLink = new yext.location.UberLaunchLink($uberLaunchLink);
    var locationField = _location.getField($uberLaunchLink.closest(context));

    var uberEmbedLink;
    if ($uberEmbedLink.length > 0) {
      uberEmbedLink = new yext.location.UberEmbedLink($uberEmbedLink);
    }

    $(uberLaunchLink).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      uberLaunchLink.reset();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        uberLaunchLink.set(response['field']);
        uberLaunchLink.storeValue();
        locationField.$display
          .empty()
          .append(response['field']['displayValue']);

        if (uberEmbedLink) {
          uberEmbedLink.update(response['field']);
        }
      }
    });
  };

  /**
   * Initialize Foursquare offer field
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initFoursquareOffer = function(context) {
    var $this = $('.js-foursquare-offer-field', context);
    if ($this.length <= 0) {
      return;
    }

    var foursquareOffer = new yext.location.FoursquareOffer($this);
    var locationField = _location.getField($this.closest(context));

    $(foursquareOffer).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        foursquareOffer.set(response['field']);
        locationField.$display
          .empty()
          .append(foursquareOffer.getDisplayValue());
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      foursquareOffer.reset();
      locationField.field.disableSubmit();
    });
  };

  /**
   * Initialize phones field
   *
   * @param {string} context Selector for the context of the field
   */
  _location.initPhones = function(context) {
    var $this = $('.js-phones-field', context);

    if ($this.length <= 0) {
      return;
    }

    var phones = new yext.location.Phones($this);
    var locationField = _location.getField($this.closest(context));

    $(phones).on('updated', function() {
      locationField.field.enableSubmit();
      _location.fieldUpdated();
    });

    locationField.$form.on('beforeSubmit.field', function() {
      locationField.field.additionalData = [{
        name: locationField.fieldName,
        value: phones.getJSONData(),
      }];
    });

    locationField.$form.on('save.field', function(e, response) {
      if (response['field']) {
        phones.set(response['field']);
        phones.storeValue();
        locationField.$display
          .empty()
          .append(phones.getDisplayValue());
      }
    });

    locationField.$form.find('.js-cancel-edit').click(function() {
      phones.reset();
      locationField.field.disableSubmit();
    });
  };

  /**
   * Bind contextual help info icons in a container
   *
   * @param {!jQuery} $container Container for which to search for info icons
   */
  _location.bindContextualHelp = function($container) {
    $container.find('.info-icon').contextualHelp();
    $container.find('.custom-info-icon').contextualHelp();
    $container.find('.js-bind-contextual-help').contextualHelp();
  };

  /**
   * Sets checkboxes to indeterminate
   *
   * @param {!jQuery} $container Set any indeterminate children to the indeterminate state
   */
  _location.setIndeterminate = function($container) {
    $container.find('.indeterminate').prop('indeterminate', true);
  };

  /**
   * Get form data as name value pairs using methods from LocationEdit and
   * then convert to object for use with Field
   *
   * @param {!jQuery} $form Form element to use as context
   * @return {!Object} Form data as name value pairs
   */
  _location.getAdditionalFormData = function($form) {
    var menus = window.serializeEnhancedLists($form, 'menus');
    var productLists = window.serializeEnhancedLists($form, 'productLists');
    var calendars = window.serializeEnhancedLists($form, 'calendars');
    var bios = window.serializeEnhancedLists($form, 'bios');

    return menus.concat(productLists, calendars, bios);
  };

  /**
   * Returns a field or array of fields by name
   *
   * @param {string} name The field name
   * @return {!Array.<LocationField>} Returns array of fields with the same name
   */
  _location.getFieldByName = function(name) {
    return fieldNameMap[name];
  };

  /**
   * This method is called when a field is updated
   *
   * TODO(mattjs) Add a LocationField argument to this method & update callers
   */
  _location.fieldUpdated = function() {
    // NOTE (mattjs) Timeout hack added to make sure that fields like gallery
    // will toggle into edit mode before they check for the field edit buttons
    setTimeout(_location.setBeforeUnload, 0);
  };

  /**
   * Sets or clears the onbeforeunload handler
   */
  _location.setBeforeUnload = function() {
    // Let the add location page handle itself
    if ($('.js-add-location-form').length) {
      return;
    }

    if (_location.hasUnsavedLocationEditFields()) {
      yext.helpers.addBeforeUnloadMessage();
    } else {
      yext.helpers.clearBeforeUnloadMessage();
    }
  };
  goog.exportSymbol('yext.location.setBeforeUnload', _location.setBeforeUnload);

  /**
   * Checks to see if any fields are in edit mode and have their submit
   * button enabled indicating that they have been updated
   *
   * @return {boolean} True if some fields have been updated
   */
  _location.hasUnsavedLocationEditFields = function() {
    var unsavedFields = false;
    $('.field-edit:visible').each(function() {
      var $this = $(this);
      var $oldSubmit = $this.find('.submit'); // Legacy fields
      var $newSubmit = $this.find('[type=submit]'); // New fields

      if ($oldSubmit.length) {
        if (!$oldSubmit.hasClass('disabled')) {
          unsavedFields = true;
          return false;
        }
      } else if ($newSubmit.length) {
        if (!$newSubmit.prop('disabled')) {
          unsavedFields = true;
          return false;
        }
      }
    });
    return unsavedFields;
  };

  /**
   * Retrieves known field ID from the row using all available techniques.
   *
   * @return {string}   known field ID
   */
  _location.getFieldIdFromRow = function($row) {
    var fieldId = $row.data('fieldId');
    if (!fieldId) {
      fieldId = $row.find('input[name="field"]').val();
    }

    return fieldId;
  };

  /**
   * Retrieves custom field ID from the row using all available techniques.
   *
   * @return {int}   custom field ID
   */
  _location.getCustomFieldIdFromRow = function($row) {
    return $row.data('customFieldId');
  };

  /**
   * Binds scheduled updates actions for old-style fields (LocationEdit.js fields).
   */
  _location.bindScheduledUpdateActionsForLegacyFields = function($row) {
    yext.scheduledupdates.bindScheduledUpdateActions(
      function() {
        return _location.getFieldIdFromRow($row);
      },
      function() {
        return _location.getCustomFieldIdFromRow($row);
      },
      $row.find('.js-scheduled-update-actions'));
  };

  var submit = function($this) {
    if ($this.hasClass('disabled')) {
      return;
    }
    window.onbeforeunload = null; // disable before submitting for add location
    $this.parents('form').submit();
    $(document).trigger('click.selectbox');
    return false;
  };
});
